import React, { ChangeEvent, CSSProperties, useRef } from 'react'

interface IProps {
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  value: string
  label: string
  type?: 'password' | 'text' | 'number'
  containerStyles?: CSSProperties
  customInputStyles?: CSSProperties
  dataTestId?: string
  error?: boolean
}

const Input = ({
  value,
  onChange,
  label,
  type = 'text',
  containerStyles,
  customInputStyles,
  dataTestId,
  error
}: IProps): JSX.Element => {
  const isValue = typeof value === 'string' ? value.length > 0 : value !== 0
  const inputRef = useRef<HTMLInputElement>(null)
  const initialLabelStyles = 'top-3 focus:top:1 active:top:1'
  const focusedLabelStyles = 'top-1 text-[13px]'
  const initialInputStyles = 'pt-4 pr-2 pl-4 pb-4 '
  const focusedInputStyles = 'pt-8 pr-2 pl-4 pb-4'
  const labelStyles = isValue ? focusedLabelStyles : initialLabelStyles
  const inputStyles = isValue ? focusedInputStyles : initialInputStyles

  return (
    <div className="relative w-full" style={containerStyles}>
      <input
        className={`rounded-4 h-[47px] text-xl outline-none box-border w-[100%] focus:shadow-[0px_0px_5px_rgba(0,0,0,0.3)] ${inputStyles} ${
          error === true ? 'border-2 border-errorRed' : ''
        }`}
        data-testid={dataTestId}
        value={value}
        onChange={onChange}
        type={type}
        ref={inputRef}
        style={{ ...customInputStyles }}
      />
      <label
        className={`absolute flex left-4 ${labelStyles}`}
        onClick={() => {
          inputRef.current?.focus()
        }}>
        {label}
      </label>
    </div>
  )
}

export default Input
